import { BusinessClock } from '../../core/time/business-clock.service';
import { clockView } from '../../core/time/business-time';
import { JstDate } from '../../core/time/business-time';
import { Component, OnInit, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { PageTitleService } from '../../core/services/page-title.service';
import { EmailReservationService } from '../../core/services/email-reservation.service';
import { EmailContentService } from '../../core/services/email-content.service';
import { StudioService } from '../../core/services/studio.service';
import { AuthStateService } from '../../core/services/auth-state.service';
import { FlashService } from '../../core/services/flash.service';
import { FlashMessageComponent } from '../../shared/components/flash-message.component';
import { UserService } from '../../core/services/user.service';

@Component({
    selector: 'app-email-reservation-new',
    imports: [RouterLink, FormsModule, FlashMessageComponent],
    template: `
<div class="animated fadeIn container-fluid">
  <div class="card">
    <div class="card-header">
      <span><i class="fa s-icon-edit"></i>&nbsp;新規作成</span>
    </div>
    <div class="card-body">
      <div class="row"><app-flash-message class="col-md-12"></app-flash-message></div>
      <form novalidate name="emailReservationNewForm">
        <div class="row">
          <div class="col-md-12">
            @if (userRole >= 30) {
              <div class="form-group row">
                <div class="col-md-4">
                  <label class="col-form-label">作成店舗</label>
                  <select class="form-control" [(ngModel)]="form.studio" name="studio" required
                    (ngModelChange)="onCreateStudioChange()">
                    @for (s of studios; track s.id) {
                      <option [ngValue]="s">{{ s.name }}</option>
                    }
                  </select>
                </div>
              </div>
            }
            <div class="form-group row">
              <div class="col-md-4">
                <label class="col-form-label">メール文面</label>
                <select class="form-control" [(ngModel)]="form.content" name="content" (ngModelChange)="onContentChange($event)">
                  <option [ngValue]="null">選択してください</option>
                  @for (c of filteredContents(); track c.id) {
                    <option [ngValue]="c">{{ c.subject }}</option>
                  }
                </select>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-12">
                <textarea type="text" class="form-control" rows="6" readonly style="background-color: #FFF">{{ form.content?.message }}</textarea>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label class="col-form-label">配信日時</label>
                <select class="form-control" [(ngModel)]="form.deliveryDate" name="deliveryDate">
                  <option [ngValue]="null">選択してください</option>
                  @for (opt of deliveryDateOptions; track opt.id) {
                    <option [ngValue]="opt">{{ opt.value }}</option>
                  }
                </select>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-8 custom-control custom-radio">
                @if (userRole <= 30) {
                  <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio" id="delivery_time_0" class="custom-control-input" [(ngModel)]="form.deliveryTime" name="deliveryTime" value="12">
                    <label class="custom-control-label" for="delivery_time_0">12時</label>
                  </div>
                }
                @if (userRole <= 10) {
                  <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio" id="delivery_time_1" class="custom-control-input" [(ngModel)]="form.deliveryTime" name="deliveryTime" value="15">
                    <label class="custom-control-label" for="delivery_time_1">15時</label>
                  </div>
                }
                @if (userRole <= 30) {
                  <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio" id="delivery_time_2" class="custom-control-input" [(ngModel)]="form.deliveryTime" name="deliveryTime" value="18">
                    <label class="custom-control-label" for="delivery_time_2">18時</label>
                  </div>
                }
              </div>
            </div>
            <div class="form-group row">
              <!-- member condition -->
              <div [class]="userRole >= 20 ? 'col-md-8' : 'col-md-6'">
                <label class="col-form-label">配信条件@if (targetCount) { ({{ targetCount }}名選択中)}</label>
                <div class="col-form-label">
                  <button type="button" class="btn btn-outline-primary" (click)="allCheckConditions()">
                    <span class="material-icons-outlined mr-1" style="font-size: inherit">done_all</span>
                    <span>&nbsp;表示店舗全選択: 会員</span>
                  </button>
                </div>
                <div style="max-height: 35em; overflow-y: auto; overflow-x: hidden;">
                  <ul class="li-padding" style="list-style: none; padding-left: 0;" >
                    @for (studio of filteredStudios(); track studio.id; let i = $index; let last = $last) {
                      <li [class.mb-3]="!last">
                        <div class="d-flex justify-content-between">
                          <div class="custom-control custom-checkbox custom-control-inline w-100">
                            <input class="custom-control-input" [id]="'check_' + i" type="checkbox"
                              [checked]="isStudioChecked(studio.id)"
                              (change)="toggleStudio(studio.id, $event)">
                            <label class="custom-control-label w-100" [for]="'check_' + i">{{ studio.name }}</label>
                          </div>
                          <button type="button" class="mt-1 mb-1 btn btn-sm btn-outline-primary" style="padding: 0; line-height: 0;"
                            (click)="toggleCollapse('aco_' + i)">
                            <span class="material-icons-outlined" style="font-size: 16px;">arrow_drop_down</span>
                          </button>
                        </div>
                        <ul [id]="'aco_' + i" class="collapse" style="list-style: none;">
                          <li>
                            <div class="custom-control custom-checkbox custom-control-inline">
                              <input class="custom-control-input" [id]="'check_' + i + '_enable'" type="checkbox"
                                [checked]="isStatusChecked(studio.id, 0)"
                                (change)="toggleStatus(studio.id, 0, $event)">
                              <label class="custom-control-label" [for]="'check_' + i + '_enable'">在籍中</label>
                            </div>
                            @if (studio.studioPlans?.length) {
                              <button type="button" class="mt-1 mb-1 btn btn-sm btn-outline-primary" style="padding: 0; line-height: 0;"
                                (click)="toggleCollapse('aco2_' + i)">
                                <span class="material-icons-outlined" style="font-size: 16px;">arrow_drop_down</span>
                              </button>
                              <ul [id]="'aco2_' + i" class="collapse" style="list-style: none;">
                                @for (studioPlan of studio.studioPlans; track studioPlan.id) {
                                  <li>
                                    <div class="custom-control custom-checkbox custom-control-inline w-100">
                                      <input class="custom-control-input"
                                        [id]="'check_' + i + '_' + studioPlan.id" type="checkbox"
                                        [checked]="isStudyPlanChecked(studio.id, studioPlan.id)"
                                        (change)="toggleStudyPlan(studio.id, studioPlan.id, $event)">
                                      <label class="custom-control-label w-100" [for]="'check_' + i + '_' + studioPlan.id">{{ studioPlan.name }}</label>
                                    </div>
                                  </li>
                                }
                              </ul>
                            }
                          </li>
                          <li>
                            <div class="custom-control custom-checkbox custom-control-inline">
                              <input class="custom-control-input" [id]="'check_' + i + '_disable'" type="checkbox"
                                [checked]="isStatusChecked(studio.id, 1)"
                                (change)="toggleStatus(studio.id, 1, $event)">
                              <label class="custom-control-label" [for]="'check_' + i + '_disable'">退会</label>
                            </div>
                          </li>
                        </ul>
                      </li>
                    }
                  </ul>
                </div>
              </div>
              <!-- user condition (admin only) -->
              @if (userRole <= 10) {
                <div class="col-md-6">
                  <label class="col-form-label">&nbsp;</label>
                  <div class="col-form-label">
                    <button type="button" class="btn btn-outline-primary" (click)="allCheckUserConditions()">
                      <span class="material-icons-outlined mr-1" style="font-size: inherit">done_all</span>
                      <span>&nbsp;表示権限全選択: ユーザー</span>
                    </button>
                  </div>
                  <div style="max-height: 35em; overflow-y: auto; overflow-x: hidden;">
                    <ul class="li-padding" style="list-style: none; padding-left: 0;">
                      <li>
                        <div class="d-flex justify-content-between">
                          <div class="custom-control custom-checkbox custom-control-inline w-100">
                            <input class="custom-control-input" id="check_fc_0" type="checkbox"
                              [checked]="userConditions[20]?.role"
                              (change)="toggleUserRole(20, $event)">
                            <label class="custom-control-label w-100" for="check_fc_0">
                              FC管理者
                              @if (userTargetCount(20) > 0) { <span> ({{ userTargetCount(20) }}名選択中)</span> }
                            </label>
                          </div>
                          <button type="button" class="mt-1 mb-1 btn btn-sm btn-outline-primary" style="padding: 0; line-height: 0;"
                            (click)="toggleCollapse('aco3_0')">
                            <span class="material-icons-outlined" style="font-size: 16px;">arrow_drop_down</span>
                          </button>
                        </div>
                        <ul id="aco3_0" class="collapse" style="list-style: none;">
                          @for (user of usersForRole(20); track user.id) {
                            <li>
                              <div class="custom-control custom-checkbox custom-control-inline">
                                <input class="custom-control-input" id="check_fc_0_{{ user.id }}" type="checkbox"
                                  [checked]="isUserChecked(20, user.id)"
                                  (change)="toggleUser(20, user.id, $event)">
                                <label class="custom-control-label" for="check_fc_0_{{ user.id }}">{{ user.name }}</label>
                              </div>
                            </li>
                          }
                        </ul>
                      </li>
                    </ul>
                    <ul class="li-padding" style="list-style: none; padding-left: 0;">
                      <li>
                        <div class="d-flex justify-content-between">
                          <div class="custom-control custom-checkbox custom-control-inline w-100">
                            <input class="custom-control-input" id="check_studio_0" type="checkbox"
                              [checked]="userConditions[30]?.role"
                              (change)="toggleUserRole(30, $event)">
                            <label class="custom-control-label w-100" for="check_studio_0">
                              店舗管理者
                              @if (userTargetCount(30) > 0) { <span> ({{ userTargetCount(30) }}名選択中)</span> }
                            </label>
                          </div>
                          <button type="button" class="mt-1 mb-1 btn btn-sm btn-outline-primary" style="padding: 0; line-height: 0;"
                            (click)="toggleCollapse('aco4_0')">
                            <span class="material-icons-outlined" style="font-size: 16px;">arrow_drop_down</span>
                          </button>
                        </div>
                        <ul id="aco4_0" class="collapse" style="list-style: none;">
                          @for (user of usersForRole(30); track user.id) {
                            <li>
                              <div class="custom-control custom-checkbox custom-control-inline">
                                <input class="custom-control-input" id="check_studio_0_{{ user.id }}" type="checkbox"
                                  [checked]="isUserChecked(30, user.id)"
                                  (change)="toggleUser(30, user.id, $event)">
                                <label class="custom-control-label" for="check_studio_0_{{ user.id }}">{{ user.name }}</label>
                              </div>
                            </li>
                          }
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
              }
            </div>
            <div class="form-group row">
              <div class="col-md-12 text-right">
                <a routerLink="/email/reservation" class="btn bg-close text-white"><i class="fa s-icon-cancel fa-fw"></i>&nbsp;閉じる</a>
                <button type="button" (click)="save()" class="btn btn-success ml-1"
                  [disabled]="saving || !form.content || !form.deliveryDate || (!isAnyConditionChecked() && !isAnyUserConditionChecked())">
                  <i class="fa s-icon-save fa-fw"></i>&nbsp;保存
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
  `
})
export class EmailReservationNewComponent implements OnInit {
  private readonly businessClock = inject(BusinessClock);
  private readonly clockContext = clockView(true);

  private pageTitleService = inject(PageTitleService);
  private emailReservationService = inject(EmailReservationService);
  private emailContentService = inject(EmailContentService);
  private studioService = inject(StudioService);
  private authState = inject(AuthStateService);
  private flash = inject(FlashService);
  private userService = inject(UserService);
  private router = inject(Router);

  form: any = { content: null, deliveryDate: null, deliveryTime: '12', studio: null };
  emailContents: any[] = [];
  studios: any[] = [];
  conditions: { [studioId: number]: any } = {};
  userConditions: { [role: number]: any } = {};
  saving = false;
  userRole = 30;
  deliveryDateOptions = this.buildDeliveryDateOptions();
  memberCount: any[] = [];
  users: any[] = [];

  get targetCount(): number {
    const memberTargets = Object.keys(this.conditions)
      .reduce((total, studioId) => total + this.memberTargetCount(Number(studioId)), 0);
    const userTargets = Object.keys(this.userConditions)
      .reduce((total, role) => total + this.userTargetCountForCondition(Number(role)), 0);
    return memberTargets + userTargets;
  }

  async ngOnInit(): Promise<void> {
    this.pageTitleService.set('配信予約', 'schedule_send', true);
    const user = this.authState.currentUser;
    if (user?.role) this.userRole = user.role;

    const [contents, studioList, memberCount, users] = await Promise.all([
      this.emailContentService.get() ?? [],
      this.userService.getStudio('own') ?? [],
      this.studioService.getMemberCount('own') ?? [],
      this.userRole <= 10 ? (this.userService.list('all') ?? []) : Promise.resolve([]),
    ]) as [any[], any[], any[], any[]];

    this.emailContents = (contents ?? []).filter((v: any) => v.status === 0);
    this.studios = studioList ?? [];
    this.memberCount = memberCount ?? [];
    this.users = users ?? [];
    if (this.studios.length && this.userRole >= 30) {
      this.form.studio = this.studios[0];
    }
  }

  filteredContents(): any[] {
    if (this.userRole >= 30 && this.form.studio) {
      return this.emailContents.filter(c => c.studioId === this.form.studio.id);
    }
    return this.emailContents;
  }

  filteredStudios(): any[] {
    if (this.userRole >= 30 && this.form.studio) {
      return this.studios.filter(s => s.id === this.form.studio.id);
    }
    return this.studios;
  }

  onContentChange(c: any): void {
    this.form.content = c;
  }

  onCreateStudioChange(): void {
    this.conditions = {};
    this.userConditions = {};
  }

  isStudioChecked(studioId: number): boolean {
    return !!this.conditions[studioId]?.studio;
  }

  isStatusChecked(studioId: number, status: number): boolean {
    return !!this.conditions[studioId]?.status?.[status];
  }

  isStudyPlanChecked(studioId: number, planId: number): boolean {
    return !!this.conditions[studioId]?.studioPlan?.[planId];
  }

  toggleStudio(studioId: number, event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    if (checked) {
      this.conditions[studioId] = { studio: true };
      this.userConditions = {};
    } else {
      delete this.conditions[studioId];
    }
  }

  toggleStatus(studioId: number, status: number, event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    if (!this.conditions[studioId]) this.conditions[studioId] = {};
    if (checked) {
      delete this.conditions[studioId].studio;
      delete this.conditions[studioId].studioPlan;
      if (!this.conditions[studioId].status) this.conditions[studioId].status = {};
      this.conditions[studioId].status[status] = true;
      this.userConditions = {};
    } else {
      delete this.conditions[studioId].status?.[status];
      if (!Object.keys(this.conditions[studioId].status ?? {}).length) {
        delete this.conditions[studioId].status;
      }
      if (!Object.keys(this.conditions[studioId]).length) {
        delete this.conditions[studioId];
      }
    }
  }

  toggleStudyPlan(studioId: number, planId: number, event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    if (!this.conditions[studioId]) this.conditions[studioId] = {};
    if (checked) {
      delete this.conditions[studioId].studio;
      delete this.conditions[studioId].status;
      if (!this.conditions[studioId].studioPlan) this.conditions[studioId].studioPlan = {};
      this.conditions[studioId].studioPlan[planId] = true;
      this.userConditions = {};
    } else {
      delete this.conditions[studioId].studioPlan?.[planId];
      if (!Object.keys(this.conditions[studioId].studioPlan ?? {}).length) {
        delete this.conditions[studioId].studioPlan;
      }
      if (!Object.keys(this.conditions[studioId]).length) {
        delete this.conditions[studioId];
      }
    }
  }

  toggleUserRole(role: number, event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    if (checked) {
      this.userConditions[role] = { role: true };
      this.conditions = {};
    } else {
      delete this.userConditions[role];
    }
  }

  usersForRole(role: number): any[] {
    return this.users.filter(user => Number(user.role) === role);
  }

  isUserChecked(role: number, userId: number): boolean {
    return !!this.userConditions[role]?.user?.[userId];
  }

  toggleUser(role: number, userId: number, event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    if (!this.userConditions[role]) this.userConditions[role] = {};
    if (checked) {
      delete this.userConditions[role].role;
      if (!this.userConditions[role].user) this.userConditions[role].user = {};
      this.userConditions[role].user[userId] = true;
      this.conditions = {};
    } else {
      delete this.userConditions[role].user?.[userId];
      if (!Object.keys(this.userConditions[role].user ?? {}).length) {
        delete this.userConditions[role].user;
      }
      if (!Object.keys(this.userConditions[role]).length) {
        delete this.userConditions[role];
      }
    }
  }

  userTargetCount(role: number): number {
    return this.userTargetCountForCondition(role);
  }

  allCheckConditions(): void {
    this.conditions = {};
    this.filteredStudios().forEach(s => {
      this.conditions[s.id] = { studio: true };
    });
    this.userConditions = {};
  }

  allCheckUserConditions(): void {
    this.userConditions = { 20: { role: true }, 30: { role: true } };
    this.conditions = {};
  }

  isAnyConditionChecked(): boolean {
    return Object.keys(this.conditions).length > 0;
  }

  isAnyUserConditionChecked(): boolean {
    return Object.keys(this.userConditions).length > 0;
  }

  toggleCollapse(id: string): void {
    const el = document.getElementById(id);
    if (el) el.classList.toggle('show');
  }

  async save(): Promise<void> {
    if (!await this.businessClock.confirm(this.clockContext, () => this.refreshClockDates())) return;
    if (!this.form.content || !this.form.deliveryDate || (!this.isAnyConditionChecked() && !this.isAnyUserConditionChecked())) return;
    this.saving = true;
    try {
      const deliveryDate = this.form.deliveryDate.id.split(',');
      const createReservation = async (studioId: number | null, targetCount: number) => {
        return this.emailReservationService.upsert({
          emailContentId: this.form.content.id,
          studioId,
          deliveryYear: deliveryDate[0],
          deliveryMonth: deliveryDate[1],
          deliveryDay: deliveryDate[2],
          deliveryHour: this.form.deliveryTime,
          targetCount,
        });
      };

      // 旧版 email-reservation.js:168-290: 追加件数を数え、配信日時超過・未許可店舗の応答はdangerで知らせる
      let memberAddCount = 0;
      let userAddCount = 0;
      let memberError: string | null = null;
      let userError: string | null = null;
      const isRejected = (value: any) => value === 'Past delivery date' || value === 'Unauthorized studio id';
      for (const studioIdText of Object.keys(this.conditions)) {
        const studioId = Number(studioIdText);
        const reservation: any = await createReservation(studioId, this.memberTargetCount(studioId));
        if (isRejected(reservation)) { memberError = reservation; continue; }
        if (!reservation?.id) continue;
        memberAddCount++;
        const condition = this.conditions[studioId];
        const payload: any[] = [];
        if (condition.studio) {
          payload.push(
            { emailReservationId: reservation.id, memberStatus: 0 },
            { emailReservationId: reservation.id, memberStatus: 1 },
          );
        }
        for (const status of Object.keys(condition.status ?? {})) {
          payload.push({ emailReservationId: reservation.id, memberStatus: Number(status) });
        }
        for (const studioPlanId of Object.keys(condition.studioPlan ?? {})) {
          payload.push({ emailReservationId: reservation.id, studioPlanId: Number(studioPlanId) });
        }
        if (payload.length) await this.emailReservationService.bulkCreateConditions(payload);
      }

      if (this.isAnyUserConditionChecked()) {
        const reservation: any = await createReservation(null, Object.keys(this.userConditions)
          .reduce((total, role) => total + this.userTargetCountForCondition(Number(role)), 0));
        if (reservation === 'Past delivery date') userError = reservation;
        if (reservation?.id) {
          userAddCount++;
          const payload: any[] = [];
          for (const roleText of Object.keys(this.userConditions)) {
            const role = Number(roleText);
            const condition = this.userConditions[role];
            if (condition.role) payload.push({ emailReservationId: reservation.id, userRole: role });
            for (const userId of Object.keys(condition.user ?? {})) {
              payload.push({ emailReservationId: reservation.id, userId: Number(userId) });
            }
          }
          if (payload.length) await this.emailReservationService.bulkCreateConditions(payload);
        }
      }
      if (memberAddCount) this.flash.create('success', `${memberAddCount}件の会員宛配信予約を追加しました。`);
      if (userAddCount) this.flash.create('success', `${userAddCount}件のユーザー宛配信予約を追加しました。`);
      if (memberError || userError) {
        let err = '配信予約ができません。';
        if (memberError === 'Past delivery date' || userError === 'Past delivery date') err = '配信日時を過ぎているため、予約ができません。';
        if (memberError === 'Unauthorized studio id') err = '配信が許可されていない店舗は、予約ができません。';
        this.flash.create('danger', err);
      }
      this.router.navigate(['/email/reservation']);
    } finally {
      this.saving = false;
    }
  }

  private memberTargetCount(studioId: number): number {
    const condition = this.conditions[studioId] ?? {};
    return this.memberCount.reduce((total, item) => {
      if (Number(item.studioId) !== studioId) return total;
      if (condition.studio) return total + Number(item.enableCount ?? 0) + Number(item.disableCount ?? 0);
      if (condition.status) {
        if (condition.status[0]) total += Number(item.enableCount ?? 0);
        if (condition.status[1]) total += Number(item.disableCount ?? 0);
      } else if (condition.studioPlan?.[item.studioPlanId]) {
        total += Number(item.enableCount ?? 0);
      }
      return total;
    }, 0);
  }

  private userTargetCountForCondition(role: number): number {
    const condition = this.userConditions[role] ?? {};
    if (condition.role) return this.users.filter(user => Number(user.role) === role).length;
    return Object.keys(condition.user ?? {}).length;
  }

  private buildDeliveryDateOptions(): { id: string; value: string }[] {
    const now = new JstDate();
    const options = [];
    const dayNames = ['日','月','火','水','木','金','土'];
    for (let i = 0; i < 14; i++) {
      const d = new JstDate(now.getFullYear(), now.getMonth(), now.getDate() + i);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      const dow = dayNames[d.getDay()];
      options.push({
        id: `${year},${d.getMonth()+1},${d.getDate()}`,
        value: `${year}年${month}月${day}日 (${dow})`,
      });
    }
    return options;
  }
  private refreshClockDates(): void {
    this.deliveryDateOptions = this.buildDeliveryDateOptions();
    this.form.deliveryDate = null;
  }

}
